import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=4e46bc93&"
import script from "./Start.vue?vue&type=script&lang=ts&"
export * from "./Start.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports